import { useState } from "react";
import { useParams } from "react-router-dom";
import { useHospitalPointById } from "../../../../api/member-management/use-hospital-detail";
import { useHospitalPointlist } from "../../../../api/member-management/use-hospital-point";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import FieldBox from "../../../../utils/Form/ui/FieldBox";
import Navigation from "../Components/navigation";
import { HospitalPointTable } from "./hospital-point-table";
import { formatPrice } from "../../../../utils";

const POINT_FILTERS = [
  { id: "", name: "전체" },
  { id: "INCOMING", name: "적립" },
  { id: "OUTGOING", name: "사용" },
];

function HospitalPointHistoryList({ hospitalId, type }) {
  const { isEmpty, getDataTableProps } = useHospitalPointlist(
    { type },
    hospitalId
  );

  return (
    <HospitalPointTable
      getDataTableProps={getDataTableProps}
      isEmpty={isEmpty}
    />
  );
}

const HospitalDetailPointPage = () => {
  const { id } = useParams();
  const [mode, setMode] = useState("");
  const { data } = useHospitalPointById(id);
  const pointData = data?.data;

  return (
    <div>
      <TitlePage title="회원조회 > 회원상세 > 병원 정보" />
      <Navigation id="point" hospitalId={id} />
      <div className="mt-8">
        <div className="flex items-center">
          <div className="w-1/2">
            <FieldBox isLast splitted label="보유 포인트">
              <span className="font-bold">
                {formatPrice(pointData?.points)}P
              </span>
            </FieldBox>
          </div>
          <div className="w-1/2">
            <FieldBox isLast splitted label="적립 예정 포인트">
              <span className="font-bold">
                {formatPrice(pointData?.pendingPoints)}P
              </span>
            </FieldBox>
          </div>
        </div>
        <div className="flex mt-8">
          {POINT_FILTERS.map((item) => (
            <div
              key={item.id || "ALL"}
              onClick={() => setMode(item.id)}
              className={`cursor-pointer w-[150px] h-10 flex justify-center items-center ${
                mode === item.id
                  ? "bg-primary-blue text-white"
                  : "text-[#999999] border border-[#dddddd]"
              } p-[5px]`}
            >
              {item.name}
            </div>
          ))}
        </div>

        <div className="mt-8">
          <HospitalPointHistoryList
            key={mode || "ALL"}
            hospitalId={id}
            type={mode}
          />
        </div>
      </div>
    </div>
  );
};

export default HospitalDetailPointPage;
